// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-select__select[data-v-6e280c3a]{max-width:300px!important}.settings-select__select[data-v-6e280c3a] .v-select__selection{font-weight:600;font-size:18px}", ""]);
// Exports
module.exports = exports;
